import _ from 'lodash'

const htmlTemplates = {
    SCRIPTS: () => {
        return `
            <script>
                var allHeadings;
                document.addEventListener("DOMContentLoaded", function(event) { 
                    allHeadings = Array.prototype.slice.call(document.querySelectorAll('h1, h2, h3, h4, h5, h6'));
                });
                function jumpTo(title,tag){
                    allHeadings.forEach(function (singleHeading){
                        if((singleHeading.localName.toLowerCase().replace(/\\u00a0/g, ' ') == tag.toLowerCase().replace(/\\u00a0/g, ' ') ) && (singleHeading.innerText.toLowerCase().replace(/\\u00a0/g, ' ')  == title.toLowerCase().replace(/\\u00a0/g, ' ') )){
                            singleHeading.scrollIntoView({behavior: 'smooth', block: 'center'});
                        }
                    })
                }
            </script>  
        `;
    },
    LABEL :  (label,textColor) => {
        return `
            <div class="topic-table-of-contents-label" style="color:${textColor} !important; font-weight: bold;
                        font-size:1rem;
                        margin-bottom: 1rem;" >
                ${label}
            </div>`
    },
    TAKEAWAYS : (customizedText,actualTitle,tag,takeaway,textColor, type) => {
        var headingStyle = '';
        if(tag.toLowerCase() === 'h2'){
            headingStyle = 'margin-left: 1rem;';
        } else if(tag.toLowerCase() === 'h3'){
            headingStyle = 'margin-left: 2rem;';
        } else if(tag.toLowerCase() === 'h4'){
            headingStyle = 'margin-left: 3rem;';
        } else if(tag.toLowerCase() === 'h5'){
            headingStyle = 'margin-left: 4rem;';
        } else if(tag.toLowerCase() === 'h6'){
            headingStyle = 'margin-left: 4rem;';
        }
        if(type === 'heading'){
            return `
                <div class="topic-table-of-contents-line topic-table-of-contents-type-${type} topic-table-of-contents-tag-${tag.toLowerCase()}" style="${headingStyle}">
                    <p onClick="jumpTo('${actualTitle}','${tag}')" style="color:${textColor} !important; font-weight: normal;
                        cursor: pointer;
                        line-height:normal;
                        margin-bottom: 1rem !important;
                        font-size: 1rem;">
                        <span style="color:inherit;
                        border-bottom: 1px solid rgba(0,0,0,0.1);
                        line-height: 1.5rem;">${customizedText}</span>
                    </p>
                </div>`
        } else{
            return `
                <div class="topic-table-of-contents-line topic-table-of-contents-type-${type} topic-table-of-contents-tag-${tag.toLowerCase()}" style="${headingStyle} margin-top: -8px;">
                    <ul style="padding-left: 4px;">
                        <li onClick="jumpTo('${actualTitle}','${tag}')" style="color:${textColor} !important; font-weight: normal;
                        cursor: pointer;
                        line-height:normal;
                        margin-bottom: 1rem !important;
                        font-size: .8rem;
                        list-style-position: outside;">
                            <span style="color:inherit;
                        border-bottom: 1px solid rgba(0,0,0,0.1);
                        line-height: 1.5rem;">${customizedText}</span>
                        </li>
                    </ul>
                </div>`
        }
    },
    STYLING: () => {
        return `<style>

                    /* Alignment */
                    @media screen and (max-width: 600px) {
                        .topic-table-of-contents-align-float-left {
                            float: none;
                            margin-right: 0;
                        }
                        .topic-table-of-contents-align-float-left .topic-table-of-contents,
                        .topic-table-of-contents-align-left .topic-table-of-contents,
                        .topic-table-of-contents-align-center .topic-table-of-contents{
                            width: auto;
                            display: block;
                        }
                    }

                    /* General Styles */

                    .topic-table-of-contents-type-heading.topic-table-of-contents-line span:hover{
                        border-bottom: 1px solid rgba(0,0,0,0.4);
                    }
                </style>`
    },
    POWERED_BY: () => {
        return `<a href="https://www.usetopic.com/wordpress-table-of-contents" style="color: transparent;"><div style="position: absolute;
                    bottom: -28px;
                    background-image: url(https://www.usetopic.com/wordpress-table-of-contents-powered-by.png);
                    background-size: contain;
                    width: 134px;
                    height: 22px;
                    background-repeat: no-repeat;
                    right: 0;
                    opacity: 0.5;
                    color: transparent;">Wordpress Table of Contents by Topic</div></a>`
    }
}

function getNextTag(tag){
    switch(tag){
            case 'H1':
            case 'h1':
                return 'h2';
            case 'H2':
            case 'h2':
                return 'h3';
            case 'H3':
            case 'h3':
                return 'h4';
            case 'H4':
            case'h4':
                return 'h5';
            case 'H5':
            case 'h5':
                return 'h6';
            case 'H6':
            case'h6':
                return 'h6';
            default:
                return 'h6';
        }
}

export function populateHeadingsForCustomization(headingObject){
    // convert nested takeaways into their own objects
    if(headingObject.headings){
        var headingsAndTakeaways = [];
        headingObject.headings.forEach((heading,index) => {
            heading.customizedText = heading.text;
            heading.selected = false;
            heading.type = 'heading';
            headingsAndTakeaways.push(heading);
            if(!_.isEmpty(heading.takeaways)){
                heading.takeaways.forEach((takeaway, index) => {
                    headingsAndTakeaways.push({
                        text: takeaway,
                        customizedText: takeaway,
                        selected: false,
                        tag: getNextTag(heading.tag),
                        type: 'takeaway',
                        headingText: heading.text,
                        isFirst: (index === 0),
                        isLast: (index === heading.takeaways.length - 1),
                        index: index
                    })
                });                
            }
        });
        return {headings: headingsAndTakeaways};
    } else{
        return [];
    }
}

export function getHTMLCode(headings, designs){
    var hasBranding = getUrlParam('nobranding') !== 'true';

    var alignmentStyles = '';
    if(designs.alignment === 'float-left'){
        alignmentStyles = 'float:left; margin-right: 2rem;';
    } else if(designs.alignment === 'left'){
        alignmentStyles = 'text-align: left;';
    } else if(designs.alignment === 'center'){
        alignmentStyles = 'text-align: center;';
    }

    return `
    <!-- Begin Table of Contents -->
    ${htmlTemplates.SCRIPTS()}
    <div class="topic-table-of-contents-container topic-table-of-contents-align-${designs.alignment}" style="position: relative; ${alignmentStyles}">
        <div class="topic-table-of-contents" style="background-color: ${designs.backgroundColor};
                        position:relative;
                        margin-bottom: 40px;
                        padding: 1.5rem;
                        border-radius:4px;
                        display: inline-block;
                        text-align: left;
                        ${designs.alignment === 'full-width' ? 'width: auto; display:block;' : 'width: 300px;'}">
        ${htmlTemplates.LABEL(designs.title, designs.textColor)}
        ${(headings.headings) ? headings.headings.map((heading) => {
            if(heading.selected){
                var linkedText = heading.type === 'heading' ? heading.text : heading.headingText; // takeaways store this in a separate field
                return htmlTemplates.TAKEAWAYS(
                    heading.customizedText,
                    linkedText,
                    heading.tag,
                    heading.customizedTakeaway,
                    designs.textColor,
                    heading.type
                    )
            } else{
                return "";
            }
        }).join(" "): ``}
        ${hasBranding ? htmlTemplates.POWERED_BY() : ''}
        ${htmlTemplates.STYLING()}
        </div>
    </div>
    <!-- End Table of Contents -->
    `
    
}

// gets URL parameters ?foo=bar
export function getUrlParam(key) {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
    vars[key] = value;
  });
  return vars[key];
}